export default __webpack_public_path__ + "static/schwierigkeitsgrad-half-3407be7f4d887c06038568662a0074b7.svg";